export const errorMessage = "An Error Occured";
export const emptyFieldMessage = (field) => `${field} is required`;
export const invalidFieldMessage = (field) => `${field} is invalid`;
